/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForSaasGcp extends models.ServiceAccountCredentialsBaseForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForSaasGcp");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForSaasGcp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForSaasGcp>): ServiceAccountCredentialsBaseForSaasGcp {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForSaasGcp(), model);
        ServiceAccountCredentialsBaseForSaasGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForSaasGcp>): ServiceAccountCredentialsBaseForSaasGcp {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForSaasGcp.newInstance(<ServiceAccountCredentialsBaseForSaasGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForSaasGcp) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForSaasGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForSaasGcp): boolean {
        if (models.ServiceAccountCredentialsBaseForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForSaasGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
